import { createAsyncThunk } from '@reduxjs/toolkit';
import { postSendInstalmentTableRowApproval } from 'store/saleInvoices/services/postSendInstalmentTableRowApproval';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

// One call: the backend sets the selected rows PENDING, creates the approval
// token and sends the row-approval email. Returns { approvalId, instalmentTable }.
export const sendInstalmentTableRowsToApproval = createAsyncThunk(
  'saleInvoices/sendInstalmentTableRowsToApproval',
  async ({ tableId, rowIds, email }, { getState }) => {
    if (!tableId) {
      throw new Error('No instalment table id provided');
    }

    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await postSendInstalmentTableRowApproval(
      selectedProjectId,
      tableId,
      rowIds,
      email
    );

    return response;
  }
);
